/*
 *
 * PosGenericPopUp
 *
 * @version 1.0.0
 * @author Serafino Busalacchi
 * @since 03-Apr-2026
 */

import PosGenericPopUp from './PosGenericPopUpContainer'

export default PosGenericPopUp
